import {CommonModule} from '@angular/common';
import {Component, computed} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TrackDirective} from '@q9elements/ui-kit/common';

import {ROUTES_PATH} from '../../models/routes-path.enum';
import {NavigationService} from '../../services/navigation.service';

type ChangesModule = {
  route: ROUTES_PATH.STORIES | ROUTES_PATH.REQUIREMENTS | ROUTES_PATH.FEEDBACKS;
  title: string;
  queryParams?: any;
  q9Track?: string;
};

@Component({
  standalone: true,
  selector: 'q9ma-changes-toolbar',
  templateUrl: './changes-toolbar.component.html',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatTabsModule,
    MatDividerModule,
    TranslateModule,
    RouterLink,
    Q9TrackDirective
  ],
  styleUrls: ['./changes-toolbar.component.scss']
})
export class ChangesToolbarComponent {
  public readonly modules: ChangesModule[] = [
    {
      route: ROUTES_PATH.REQUIREMENTS,
      title: 'REQUIREMENTS.REQUIREMENT_TITLE',
      q9Track: 'requirements_requirement_title'
    },
    {route: ROUTES_PATH.STORIES, title: 'STORIES.LABEL', q9Track: 'stories_label'},
    {
      route: ROUTES_PATH.FEEDBACKS,
      title: 'FEEDBACK.FEEDBACKS_TAB',
      queryParams: {ref: 'active'},
      q9Track: 'feedback_feedback_header'
    }
  ];
  private readonly currentUrl = toSignal(this.activatedRoute.parent!.url);
  public currentModule = computed(() => {
    const [module] = this.currentUrl()!;

    return String(module);
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService
  ) {}

  public navigateTo(module: ChangesModule) {
    return this.navigationService.navigateToModule(module.route, module.queryParams);
  }
}
